import { render } from "./footer-unfixed.vue?vue&type=template&id=4534b8dc"
import script from "./footer-unfixed.vue?vue&type=script&lang=js"
export * from "./footer-unfixed.vue?vue&type=script&lang=js"

import "./footer-unfixed.vue?vue&type=style&index=0&id=4534b8dc&lang=scss"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__